import $ from 'jquery';
import {isEmpty, dragToScroll, isMobile, isRtl} from '../Helpers';
import slick from 'slick-carousel'


export default class Jobs {

    static main        = $('#jobs-main');
    static formrap     = $('#form_wrap');
    static sucsessWrap = $('#form-sucsess');

    static form;
    static jobTitle;
    static sucsessText;

    static is_jobs_page(){
        return !isEmpty(Jobs.main);
    }
    static init(){
        if(!this.is_jobs_page()){
            return;
        }
        this._data = {};
        var jobTitles  = Jobs.main.find('.job-item a.job-title');
        var jobActions = Jobs.main.find('.job-item-action a');
        Jobs.form      = Jobs.formrap.find('form');
        Jobs.jobTitle  = Jobs.formrap.find('#job-title');
        var closeForm  = Jobs.formrap.find('#close-form');
        var wpcf7Elm   = document.querySelector( '.wpcf7' );
        Jobs.sucsessText  = Jobs.sucsessWrap.find('#sucsess-text');
        var closeSucsess = Jobs.sucsessWrap.find('#close-sucsess');
        var clients = $( '#jobs-page .customers-list' );

        closeForm.on('click',Jobs.closeJobForm);
        jobTitles.on('click',Jobs.toggleJobItem);
        jobActions.on('click',Jobs.openJobForm);
        closeSucsess.on('click',Jobs.closeJobForm);

        wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
            Jobs.formResponse(event,true);
        });
        wpcf7Elm.addEventListener( 'wpcf7mailfailed', function( event ) {
            Jobs.formResponse(event,false);
        });
        wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
            Jobs.formResponse(event,false);
        });
        if(!isMobile()){
            clients.slick({
                rtl: isRtl(),
                slidesToShow: 5,
                slidesToScroll: 5,
                arrows: true,
                autoplay:  true,
                autoplaySpeed:4000
            });
        }

    }


    static closeJobForm(e) {
        e.preventDefault();
        Jobs.formrap.removeClass('is-open');
        Jobs.sucsessWrap.removeClass('is-open');
        Jobs.main.focus();
        $('html,body').animate({ scrollTop: 0 }, 300);

    }
    static openJobForm(e) {
        e.preventDefault();
        var item = $(e.delegateTarget).parents('.job-item');
        var title = item.attr('data-title');
        Jobs.form.find('[name="c-job"]').val(title);
        Jobs.jobTitle.text(title);
        Jobs.formrap.addClass('is-open');
        $('html,body').animate({ scrollTop: Jobs.formrap.offset().top }, 300);

    }
    static toggleJobItem(e) {
        e.preventDefault();
        var item = $(e.delegateTarget).parent();
        item.toggleClass('is-open');
        item.attr('aria-expanded',item.hasClass('is-open') ? 'true' : 'false');
        item.find('.job-item-content').slideToggle('fast');
    }
    static formResponse(res,sucsses){
        $('.wpcf7-response-output').remove();

        if(!!!res || !!!res.detail?.apiResponse){
            return;
        }
        var apiResponse = res.detail.apiResponse;
        if(!apiResponse.hasOwnProperty('into') || $('.wpcf7' + apiResponse.into).length === 0) {
            return;
        }

        if(sucsses){
            Jobs.sucsessText.html(apiResponse.message);
            Jobs.sucsessWrap.addClass('is-open');
            Jobs.formrap.removeClass('is-open');
            Jobs.main.focus();
        }


    }

}
